import { VStack } from "@chakra-ui/react"
import React from "react"
import { AssignTagForm } from "../../forms"
import { UserFragment } from "../../graphql"

export type AssignTagProps = {
	user: UserFragment
}

export const AssignTag: React.FC<AssignTagProps> = ({ user }) => {
	return (
		<VStack w="full" align="stretch" spacing={6}>
			<AssignTagForm user={user} />
		</VStack>
	)
}
